import React from 'react'
import { inject, observer } from 'mobx-react'
import Icon from 'components/common/Icon'
import Name from '../common/Name'
import SharedMessage from '../common/SharedMessage'
import { withTranslation } from 'react-i18next'

const SharedTargetGroup = ({ group, uiStore, t }) => (
  <div className='owned-geopolygon'>
    <Name
      label={t('TARGET_GROUP.TARGET_GROUP')}
      name={group.name}
    />
    <SharedMessage group={group} />
    <section className='owned-geopolygon__list'>
      <button onClick={e => {
        e.currentTarget.blur()
        uiStore.setBoundsToItem(group)
      }}
      >
        <Icon id='fit-region' extraClasses={['icon-lg']} />
        <span>{t('GLOBAL.FIT_REGION')}</span>
      </button>
    </section>
  </div>
)

export default withTranslation()(inject('uiStore')(observer(SharedTargetGroup)))
